export enum RmAuthorities {
    ROLE_ADMIN = 'ROLE_ADMIN',
    ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
    ROLE_USER = 'ROLE_USER',
    ROLE_CUSTOMER = 'ROLE_CUSTOMER',
    ROLE_ANONYMOUS = 'ROLE_ANONYMOUS'
}
